function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeWidth: 0.802,
  transform: "matrix(-1.2484 0 0 1.2484 -4.155 -6.276)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: -38,
  cy: 38,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  cx: -38,
  cy: 38,
  r: 6.98
}), /*#__PURE__*/React.createElement("circle", {
  cx: -14,
  cy: 38,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  cx: -14,
  cy: 38,
  r: 6.98
})), /*#__PURE__*/React.createElement("path", {
  d: "M32.703 37.418c-3.15 1.248-5.648 1.248-8.656 0M32.703 44.908c-3.15-1.248-5.665-1.122-8.656 0",
  strokeWidth: 1
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeWidth: 0.801
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.163 35.67L41.708 15.677a5.91 5.91 0 00-4.775-2.418c-3.236 0-5.86 2.624-5.816 5.771l2.071 17.14M3.445 35.67l11.454-19.993a5.91 5.91 0 014.775-2.418c3.236 0 5.86 2.624 5.816 5.771L23.42 36.17",
  strokeWidth: 1
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.133 18.055c-2.056.815-3.685.815-5.648 0M28.304 18.692v19.975",
  fill: "none",
  stroke: "var(--primary-color, #000)"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeWidth: 0.801
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.311 13.648l-1.312-2.447a3.291 3.291 0 00-2.659-1.346c-1.802 0-3.263 1.461-3.239 3.214l.27 2.237M17.296 13.648l1.312-2.447a3.291 3.291 0 012.659-1.346c1.802 0 3.263 1.461 3.238 3.214l-.27 2.237",
  strokeWidth: 1
}));

var SvgBinoculars = function SvgBinoculars(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBinoculars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Binoculars.be4912b0.svg";
export { ForwardRef as ReactComponent };